import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "basicOfferEndBackground ml-2 mr-4" }
const _hoisted_2 = { class: "basicOfferBackground ml-2 mr-6" }
const _hoisted_3 = { class: "essentialOfferEndBackground ml-2 mr-4" }
const _hoisted_4 = { class: "essentialOfferBackground ml-2 mr-4" }
const _hoisted_5 = { class: "premiumOfferEndBackground ml-2 mr-4" }
const _hoisted_6 = { class: "premiumOfferBackground ml-2 mr-4" }
const _hoisted_7 = { class: "essentialOfferEndBackground ml-2 mr-4" }
const _hoisted_8 = { class: "essentialOfferBackground ml-2 mr-8" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { dense: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "4" }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "offerTitleBackground"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, { class: "d-flex justify-center align-center basicOfferTitle" }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("FREEMIUM")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "offerTitleBackground"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, { class: "d-flex justify-center align-center essentialOfferTitle" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" SMART ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "offerTitleBackground"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, { class: "d-flex justify-center align-center essentialOfferTitle" }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("ESSENTIEL")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "offerTitleBackground"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, { class: "d-flex justify-center align-center premiumOfferTitle" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("PREMIUM")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, {
          dense: "",
          style: _normalizeStyle({ 'overflow-y': 'auto', 'max-height': _ctx.maxHeight, 'overflow-x': 'hidden' })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheme, (category, categories_index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: categories_index }, [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, { class: "titleCategory" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(category.title), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        (category.basicOffer && category.basicOffer.colorised)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2",
                              class: "pb-0 pt-0"
                            }, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createElementVNode("div", { class: "basicOfferBackground ml-2 mr-4 pb-0 pt-0" }, null, -1)
                              ])),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "2",
                              class: "pb-0 pt-0"
                            })),
                        (category.smartOffer && category.smartOffer.colorised)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "2",
                              class: "pb-0 pt-0"
                            }, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createElementVNode("div", { class: "essentialOfferBackground ml-2 mr-4 pb-0 pt-0" }, null, -1)
                              ])),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "2",
                              class: "pb-0 pt-0"
                            })),
                        (category.essentialOffer && category.essentialOffer.colorised)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 4,
                              cols: "2",
                              class: "pb-0 pt-0"
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createElementVNode("div", { class: "premiumOfferBackground ml-2 mr-4 pb-0 pt-0" }, null, -1)
                              ])),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_col, {
                              key: 5,
                              cols: "2",
                              class: "pb-0 pt-0"
                            })),
                        (category.premiumOffer && category.premiumOffer.colorised)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 6,
                              cols: "2",
                              class: "pb-0 pt-0"
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createElementVNode("div", { class: "essentialOfferBackground ml-2 mr-4 pb-0 pt-0" }, null, -1)
                              ])),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_col, {
                              key: 7,
                              cols: "2",
                              class: "pb-0 pt-0"
                            }))
                      ]),
                      _: 2
                    }, 1024),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.categories, (subCategory, index) => {
                      return (_openBlock(), _createBlock(_component_v_row, {
                        key: categories_index * 10000 + (index + 1),
                        dense: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_sheet, { class: "titleSubCategory" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(subCategory.title), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (
                                    subCategory.basicOffer &&
                                    subCategory.basicOffer.colorised &&
                                    subCategory.basicOffer.isEnd
                                )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "2",
                                class: "pb-0 pt-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_1, [
                                    (
                                            subCategory.basicOffer && subCategory.basicOffer.valid
                                        )
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          class: "d-flex justify-center basicOfferIcon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(subCategory.basicOffer.icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : (
                                    subCategory.basicOffer && subCategory.basicOffer.colorised
                                )
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 1,
                                  cols: "2",
                                  class: "pb-0 pt-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                      (
                                            subCategory.basicOffer && subCategory.basicOffer.valid
                                        )
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            class: "d-flex justify-center basicOfferIcon"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(subCategory.basicOffer.icon), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 2,
                                  cols: "2",
                                  class: "pb-0 pt-0"
                                })),
                          (
                                    subCategory.smartOffer &&
                                    subCategory.smartOffer.colorised &&
                                    subCategory.smartOffer.isEnd
                                )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 3,
                                cols: "2",
                                class: "pb-0 pt-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, [
                                    (
                                            subCategory.smartOffer &&
                                            subCategory.smartOffer.valid
                                        )
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          class: "d-flex justify-center essentialOfferIcon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(subCategory.smartOffer.icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : (
                                    subCategory.smartOffer &&
                                    subCategory.smartOffer.colorised
                                )
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 4,
                                  cols: "2",
                                  class: "pb-0 pt-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                      (
                                            subCategory.smartOffer &&
                                            subCategory.smartOffer.valid
                                        )
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            class: "d-flex justify-center essentialOfferIcon"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(subCategory.smartOffer.icon), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 5,
                                  cols: "2",
                                  class: "pb-0 pt-0"
                                })),
                          (
                                    subCategory.essentialOffer &&
                                    subCategory.essentialOffer.colorised &&
                                    subCategory.essentialOffer.isEnd
                                )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 6,
                                cols: "2",
                                class: "pb-0 pt-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    (
                                            subCategory.essentialOffer &&
                                            subCategory.essentialOffer.valid
                                        )
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          class: "d-flex justify-center premiumOfferIcon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(subCategory.essentialOffer.icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : (
                                    subCategory.essentialOffer &&
                                    subCategory.essentialOffer.colorised
                                )
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 7,
                                  cols: "2",
                                  class: "pb-0 pt-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                      (
                                            subCategory.essentialOffer &&
                                            subCategory.essentialOffer.valid
                                        )
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            class: "d-flex justify-center premiumOfferIcon"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(subCategory.essentialOffer.icon), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 8,
                                  cols: "2",
                                  class: "pb-0 pt-0"
                                })),
                          (
                                    subCategory.premiumOffer &&
                                    subCategory.premiumOffer.colorised &&
                                    subCategory.premiumOffer.isEnd
                                )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 9,
                                cols: "2",
                                class: "pb-0 pt-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    (
                                            subCategory.premiumOffer &&
                                            subCategory.premiumOffer.valid
                                        )
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          class: "d-flex justify-center essentialOfferIcon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(subCategory.premiumOffer.icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : (
                                    subCategory.premiumOffer && subCategory.premiumOffer.colorised
                                )
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 10,
                                  cols: "2",
                                  class: "pb-0 pt-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      (
                                            subCategory.premiumOffer &&
                                            subCategory.premiumOffer.valid
                                        )
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            class: "d-flex justify-center essentialOfferIcon"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(subCategory.premiumOffer.icon), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 11,
                                  cols: "2",
                                  class: "pb-0 pt-0"
                                }))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ], 64))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }),
    (_ctx.isDisplayPrice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, null, {
                    activator: _withCtx(({ props }) => [
                      _createElementVNode("div", null, [
                        _cache[9] || (_cache[9] = _createTextVNode("Tarif €/mois ")),
                        _createVNode(_component_v_icon, _normalizeProps(_guardReactiveProps(props)), {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode("$oss-help")
                          ])),
                          _: 2
                        }, 1040)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _cache[10] || (_cache[10] = _createTextVNode(" 1 société, 3 utilisateurs avec tous les droits, un nombre illimité d'utilisateurs à droit restreints au dépôt de pièces et gestion des notes de frais "))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(!_ctx.isWithoutLogingView ? _ctx.basicPrice : "0 €"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(!_ctx.isWithoutLogingView ? _ctx.smartPrice : "49 €"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(!_ctx.isWithoutLogingView ? _ctx.essentialPrice : "69 €"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(!_ctx.isWithoutLogingView ? _ctx.premiumPrice : "99 €"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "4",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" Tarif €/mois pour une SCI ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createElementVNode("strong", null, "/", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createElementVNode("strong", null, "19 €", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("strong", null, "19 €", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createElementVNode("strong", null, "19 €", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "4",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createElementVNode("span", { size: "x-small" }, "Tarif €/mois/Utilisateur Supplémentaire", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createElementVNode("strong", { size: "x-small" }, "/", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createElementVNode("strong", { size: "x-small" }, "9 €", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createElementVNode("strong", { size: "x-small" }, "9 €", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createElementVNode("strong", { size: "x-small" }, "9 €", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "4",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createElementVNode("span", { size: "x-small" }, "Durée d'engagement minimale", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("strong", { size: "x-small" }, "1 mois", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createElementVNode("strong", { size: "x-small" }, "12 mois", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createElementVNode("strong", { size: "x-small" }, "12 mois", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createElementVNode("strong", { size: "x-small" }, "12 mois", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "4",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createElementVNode("span", { size: "x-small" }, "Parcours eLearning (obligatoire)", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createElementVNode("strong", { size: "x-small" }, "-", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createElementVNode("strong", { size: "x-small" }, "150€/ utilisateur", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createElementVNode("strong", { size: "x-small" }, "150€/ utilisateur", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex justify-center align-center",
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createElementVNode("strong", { size: "x-small" }, "150€/ utilisateur", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}